module.exports = __webpack_public_path__ + "img/award04_04.2c747fdb.png";